<template>
  <div class="container_view">
    <v-card class="content_card" elevation="10" variant="flat">
      <header>
        <v-card-title>Gestiones</v-card-title>
        <v-divider class="mx-3"></v-divider>
      </header>

      <div class="content_accion" v-if="!isLoading">
        <v-expansion-panels v-model="panel">
          <v-expansion-panel>
            <v-expansion-panel-title>Filtros</v-expansion-panel-title>
            <v-expansion-panel-text>
              <div class="override_content_flex mt-4">
                <div class="col-flex-2">
                  <v-text-field type="date" variant="outlined" label="Fecha Inicio"
                    v-model="formGroup.data.fecha_inicial" :rules="formGroup.rules.fecha_inicial"></v-text-field>
                </div>
                <div class="col-flex-2">
                  <v-text-field type="date" variant="outlined" label="Fecha Fin" :min="formGroup.data.fecha_inicial"
                    :max="validateMaxDate()" v-model="formGroup.data.fecha_final"
                    :rules="formGroup.rules.fecha_final"></v-text-field>
                </div>
                <div class="col-flex-3" v-if="tipoUsuario === 'Multiadmin'">
                  <v-select v-model="formGroup.data.despacho" label="Despachos" :items="arrDespachos" variant="outlined"
                    item-title="nombre" item-value="id_db" @update:model-value="getGrupos"
                    prepend-inner-icon="mdi-magnify"></v-select>
                </div>
                <div class="col-flex-3">
                  <v-select v-model="formGroup.data.codigo_accion" label="Códigos Acción" :items="arrActionCode"
                    variant="outlined" item-title="nombre" item-value="id_codigo_accion"
                    prepend-inner-icon="mdi-magnify"></v-select>
                </div>
                <div class="col-flex-2"
                  v-if="tipoUsuario === 'Administrador' || tipoUsuario === 'Supervisor' || tipoUsuario === 'Multiadmin'">
                  <v-autocomplete v-model="formGroup.data.id_grupo" label="Grupos" variant="outlined"
                    :items="arrGroupList" item-title="nombre" item-value="id_grupo" prepend-inner-icon="mdi-magnify"
                    @update:model-value="getUsersByGroups()"></v-autocomplete>
                </div>
                <div class="col-flex-3"
                  v-if="tipoUsuario === 'Administrador' || tipoUsuario === 'Supervisor' || tipoUsuario === 'Multiadmin'">
                  <v-select v-if="!isLoadingUsers" v-model="formGroup.data.usuarios" :rules="formGroup.rules.usuarios"
                    label="Usuarios" variant="outlined" :items="arrUsersByGroups"
                    :disabled="arrUsersByGroups.length === 0" item-title="fullName" item-value="id"
                    prepend-inner-icon="mdi-magnify" multiple>
                    <template v-slot:prepend-item>
                      <v-list-item title="Seleccionar todos" @click="toggleSelectAll">
                        <template v-slot:prepend>
                          <v-checkbox-btn :color="someSelected ? 'indigo-darken-4' : undefined"
                            :indeterminate="someSelected && !allSelected" :model-value="allSelected" />
                        </template>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                  <div v-if="isLoadingUsers" style="margin-top: 26px">
                    <v-progress-linear indeterminate></v-progress-linear>
                  </div>
                  <div
                    v-if="formGroup.data.id_grupo && (!formGroup.data.usuarios || formGroup.data.usuarios.length === 0) && !isLoadingUsers"
                    class="text-caption text-red">
                    Selecciona los usuarios del grupo.
                  </div>
                </div>
                <div class="col-flex-12 actions_buttons">
                  <v-btn color="indigo-darken-3" style="margin-top: 5px" prepend-icon="mdi-plus" text="Buscar"
                    :disabled="validateFilter()" @click="checkTypeFilter()"></v-btn>
                </div>
              </div>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

      <div v-if="!isLoading && !isLoadingFilter" style="width: 100%; height: calc(100% - 127px); overflow: auto">
        <apexchart v-if="typeChart === 'bar'" height="95%" :type="typeChart" :options="chartOptionsBar"
          :series="seriesBar">
        </apexchart>
        <apexchart v-if="typeChart === 'donut'" height="95%" :type="typeChart" :options="chartOptionsPie"
          :series="seriesPie">
        </apexchart>
      </div>

      <div v-if="isLoading" class="content_load h-100">
        <v-progress-circular :size="100" :width="7" color="indigo-darken-3" indeterminate></v-progress-circular>
        <i>Espere un Momento</i>
        <div>Cargando Información</div>
      </div>
      <div v-if="isLoadingFilter" class="content_load h-100">
        <v-progress-circular :size="100" :width="7" color="indigo-darken-3" indeterminate></v-progress-circular>
        <i>Espere un Momento</i>
        <div>Cargando Información de la Gráfica</div>
      </div>
    </v-card>
  </div>
  <SnackbarComponent :value="snackbarData" />
</template>

<script>
import SnackbarComponent from "@/components/Snackbar.vue";
import { EncryptService } from "@/services/EncryptService";
import { EstadisticaService } from "@/services/EstadisticaService";
// import { SocketService } from '@/services/SocketService
import io from "socket.io-client";

import VueApexCharts from "vue3-apexcharts";
export default {
  name: "EstadisticaGestiones",
  components: {
    SnackbarComponent,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      isLoading: false,
      isLoadingFilter: false,
      isLoadingUsers: false,
      panel: [],
      totalGen: 0,
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
      chartOptionsBar: {
        chart: {
          id: "vuechart-example",
        },
        title: {
          text: 'Total: ',
          align: 'center',
          style: {
            fontSize: '15px',
            fontWeight: 'bold',
            color: '#263238'
          }
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: function (value) {
              if (!value) return "";

              let value2 = String(value).split(' ');

              return value2;
            },
            style: {
              fontSize: '10px',   // 👈 tamaño de letra
              colors: ['#263238'], // puedes pasar array o un solo color
              whiteSpace: 'pre-line'
            }
          }
        },
      },
      seriesBar: [],

      chartOptionsPie: {
        chart: {
          width: 380,
          type: "donut",
          id: "vuechart-donut",
          toolbar: {
            show: true, // Enables the toolbar
            tools: {
              download: true, // Enables the download button
            }
          }
        },
        labels: [], // Aquí defines los nombres de las categorías
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Total",
                  fontSize: "20px",
                  color: "#373d3f",
                  formatter: function () {
                    return 12 // Aquí usamos el valor computado
                  },
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        legend: {
          position: "right", // Coloca la leyenda a la derecha
          formatter: function (seriesName, opts) {
            // Obtiene el valor asociado al índice actual
            let value = opts.w.globals.series[opts.seriesIndex];
            return `${seriesName} (${value})`; // Personaliza la leyenda con nombre y valor
          },
        },
      },
      seriesPie: [],

      formGroup: {
        data: {
          fecha_inicial: null,
          fecha_final: null,
          codigo_accion: null,
          id_grupo: null,
          usuarios: [],
          despacho: null
        },
        rules: {
          fecha_inicial: [
            (value) => {
              if (value === null || value === undefined || value === "") {
                return `El campo es obligatorio`;
              }
              return true;
            },
          ],
          fecha_final: [
            (value) => {
              if (value === null || value === undefined || value === "") {
                return `El campo es obligatorio`;
              }
              return true;
            },
          ],
        },
      },
      arrActionCode: [],
      arrGroupList: [],
      arrUsersByGroups: [],
      tipoUsuario: "",
      typeChart: "bar",
      typeFilterChart: null,
      responseFilter: null,
      dispatch: null,
      arrDespachos: [],
      selectedUserIds: [],
      isSelectingAll: false
    };
  },
  async created() {
    this.isLoading = true;

    const ENC_DISPATCH = localStorage.getItem("DESPACHO");
    this.dispatch = await EncryptService.decrypt(`${ENC_DISPATCH}`);

    this.tipoUsuario = await EncryptService.decrypt(
      localStorage.getItem("TIPO")
    );
    await this.getDespachos();
    await this.getActionCodeList();
    await this.getGrupos();

    this.isLoading = false;
  },
  computed: {
    allSelected() {
      const usuarios = this.formGroup?.data?.usuarios || [];
      const users = this.arrUsersByGroups || [];
      return usuarios.length === users.length && users.length > 0;
    },
    someSelected() {
      const usuarios = this.formGroup?.data?.usuarios || [];
      return usuarios.length > 0 && !this.allSelected;
    }
  },
  async mounted() {
    const socket = io("https://sms2024.ddns.net:3000");
    socket.on("nueva_gestion", (data) => {
      if (this.typeFilterChart !== null) {
        switch (this.typeFilterChart) {
          case 1:
            if (data.despacho === this.dispatch) {
              this.seriesBar[0].data[0] = this.seriesBar[0].data[0] + 1;
            }
            break;
          case 2:
            if (
              this.chartOptionsBar.xaxis.categories.includes(data.created_at)
            ) {
              const INDEX = this.chartOptionsBar.xaxis.categories.findIndex(
                (element) => element === data.created_at
              );
              if (this.seriesBar[0].name === data.username) {
                this.seriesBar[0].data[INDEX] =
                  this.seriesBar[0].data[INDEX] + 1;
              }
            }
            break;
          case 3:
            if (this.chartOptionsBar.xaxis.categories.includes(data.username)) {
              const INDEX = this.chartOptionsBar.xaxis.categories.findIndex(
                (element) => element === data.username
              );
              this.seriesBar[0].data[INDEX] = this.seriesBar[0].data[INDEX] + 1;
            }
            break;
          case 4:
            if (data.codigo_accion === this.formGroup.data.codigo_accion) {
              if (this.chartOptionsPie.labels.includes(data.descripcion)) {
                const INDEX = this.chartOptionsPie.labels.findIndex(
                  (element) => element === data.descripcion
                );
                this.seriesPie[INDEX] = this.seriesPie[INDEX] + 1;
              } else {
                this.chartOptionsPie.labels.push(data.descripcion);
                this.seriesPie.push(1);
              }
            }
            break;
          case 5:
            if (
              this.formGroup.data.usuarios !== null &&
              this.formGroup.data.usuarios.includes(data.id_usuario)
            ) {
              if (data.codigo_accion === this.formGroup.data.codigo_accion) {
                if (
                  this.chartOptionsPie.labels.includes(data.descripcion)
                ) {
                  const INDEX = this.chartOptionsPie.labels.findIndex(
                    (element) => element === data.descripcion
                  );
                  this.seriesPie[INDEX] = this.seriesPie[INDEX] + 1;
                } else {
                  this.chartOptionsPie.labels.push(data.descripcion);
                  this.seriesPie.push(1);
                }
              }
            }
            break;
          default:
            this.snackbarData.description = `Opción no disponible`;
            this.snackbarData.openSnackbar = true;
            break;
        }
      }
    });
  },
  unmounted() {
    this.typeFilterChart = null;
  },
  methods: {
    validateMaxDate: function () {
      let FECHA_INICIAL = this.formGroup.data.fecha_inicial;
      if (FECHA_INICIAL === null) {
        return;
      }
      let arrDateInit = FECHA_INICIAL.split("-");
      let dateInitial = new Date(
        parseInt(arrDateInit[0]),
        parseInt(arrDateInit[1]) - 1,
        arrDateInit[2]
      );

      dateInitial.setDate(dateInitial.getDate() + 32);

      let year = dateInitial.getFullYear();
      let month =
        dateInitial.getMonth() + 1 < 10
          ? `0${dateInitial.getMonth() + 1}`
          : dateInitial.getMonth() + 1;
      let date =
        dateInitial.getDate() < 10
          ? `0${dateInitial.getDate()}`
          : dateInitial.getDate();
      let strMaxDate = `${year}-${month}-${date}`;
      return strMaxDate;
    },
    getActionCodeList: async function () {
      await EstadisticaService.getActionCode().then((resp) => {
        if (!resp.error) {
          this.arrActionCode = resp.response;
          this.arrActionCode.forEach((element) => {
            element.nombre = element.codigo + " - " + element.descripcion;
          });
        } else {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: resp.msg,
          };
        }
      });
    },
    getGrupos: async function () {
      if (this.tipoUsuario == "Administrador") {
        await EstadisticaService.getGruposAdmin(
          localStorage.getItem("TIPO"),
          null
        ).then((resp) => {
          if (!resp.error) {
            this.arrGroupList = [{ id_grupo: null, nombre: "Ninguno" }];
            this.arrGroupList = this.arrGroupList.concat(resp.response);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        });
      } else if (this.tipoUsuario == "Multiadmin") {
        this.formGroup.data.id_grupo = null;
        this.formGroup.data.usuarios = null;
        await EstadisticaService.getGruposAdmin(localStorage.getItem("TIPO"), this.formGroup.data.despacho).then((resp) => {

          if (!resp.error) {
            this.arrGroupList = [{ id_grupo: null, nombre: "Ninguno" }];
            this.arrGroupList = this.arrGroupList.concat(resp.response);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        });
      } else {
        const ID = localStorage.getItem("ID");
        const ENC_ID = await EncryptService.encrypt(`${ID}`);
        await EstadisticaService.getGruposSupervisor(ENC_ID).then((resp) => {
          if (!resp.error) {
            this.arrGroupList = resp.response;
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        });
      }
    },
    getUsersByGroups: async function () {
      this.isLoadingUsers = true;
      const ID_GROUP = this.formGroup.data.id_grupo;
      if (ID_GROUP === null) {
        this.formGroup.data.usuarios = null;
        this.arrUsersByGroups = [];
        this.isLoadingUsers = false;
        return;
      }
      const ENC_GROUP = await EncryptService.encrypt(`${ID_GROUP}`);
      await EstadisticaService.getUsersByGroups(ENC_GROUP).then(
        (responseData) => {
          if (!responseData.error) {
            for (let element of responseData.response) {
              element.fullName = `${element.name} ${element.last_name} (${element.username})`;
            }

            this.arrUsersByGroups = responseData.response;

          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: responseData.msg,
            };
          }
        }
      );
      this.formGroup.data.usuarios = null;
      this.isLoadingUsers = false;
    },
    validateFilter: function () {
      const FECHA_INICIAL = this.formGroup.data.fecha_inicial;
      if (FECHA_INICIAL === null || FECHA_INICIAL === undefined || FECHA_INICIAL === ""
      ) {
        return true;
      }
      const FECHA_FINAL = this.formGroup.data.fecha_final;
      if (FECHA_FINAL === null || FECHA_FINAL === undefined || FECHA_FINAL === "") {
        return true;
      }

      if (this.tipoUsuario == 'Multiadmin') {
        const DESPACHOS = this.formGroup.data.despacho;
        if (DESPACHOS == null || DESPACHOS == undefined || DESPACHOS == '') {
          return true;
        }
      }

      return false;
    },
    checkTypeFilter: async function () {
      const CODIGO_ACCION = this.formGroup.data.codigo_accion;
      if (CODIGO_ACCION === null || CODIGO_ACCION === undefined || CODIGO_ACCION === "") {
        this.typeChart = "bar";
        await this.applyFilterBar();
      } else {
        this.typeChart = "donut";
        await this.applyFilterCake();
      }
    },
    applyFilterBar: async function () {
      this.isLoadingFilter = true;

      this.seriesBar = [];
      this.chartOptionsBar.xaxis.categories = [];

      const FECHA_INICIAL = this.formGroup.data.fecha_inicial;
      const FECHA_FINAL = this.formGroup.data.fecha_final;
      let USUARIOS = [];
      if (this.tipoUsuario === "Administrador" || this.tipoUsuario === "Supervisor" || this.tipoUsuario === "Multiadmin") {
        USUARIOS = this.formGroup.data.usuarios;
        if (USUARIOS === null || USUARIOS === undefined || USUARIOS.length === 0) {
          USUARIOS = [];
        } else {
          let arrTemp = [];
          for (let element of USUARIOS) {
            element = await EncryptService.encrypt(`${element}`);
            arrTemp.push(element);
          }
          USUARIOS = arrTemp;
        }
      } else {
        const ID = localStorage.getItem("ID");
        const ENC_ID = await EncryptService.encrypt(`${ID}`);
        USUARIOS = [ENC_ID];
      }

      let arrDateInit = FECHA_INICIAL.split("-");
      let dateInitial = new Date(
        parseInt(arrDateInit[0]),
        parseInt(arrDateInit[1]) - 1,
        arrDateInit[2]
      );

      let despacho = '';
      if (this.tipoUsuario === "Multiadmin") {
        despacho = this.formGroup.data.despacho;
      } else {
        despacho = localStorage.getItem('DESPACHO');
      }

      let arrDateFinal = FECHA_FINAL.split("-");
      let dateFinal = new Date(
        parseInt(arrDateFinal[0]),
        parseInt(arrDateFinal[1]) - 1,
        arrDateFinal[2]
      );

      let arrDates = this.getBetweenDates(dateInitial, dateFinal);
      let arrStrDate = [];
      for (const DATE of arrDates) {
        let year = DATE.getFullYear();
        let month =
          DATE.getMonth() + 1 < 10
            ? `0${DATE.getMonth() + 1}`
            : DATE.getMonth() + 1;
        let date = DATE.getDate() < 10 ? `0${DATE.getDate()}` : DATE.getDate();
        let strDate = `${year}-${month}-${date}`;
        arrStrDate.push(strDate);
      }

      const REQUEST_FILTER = {
        fecha_inicial: FECHA_INICIAL,
        fecha_final: FECHA_FINAL,
        id_user_list: USUARIOS,
        despacho: despacho
      };
      await EstadisticaService.getDataGraficas(REQUEST_FILTER).then(
        (responseData) => {
          if (
            !responseData.error &&
            responseData.msg !==
            "No hay estadisticas disponibles para este usuario/s"
          ) {
            this.responseFilter = responseData.response;
            if (USUARIOS.length === 0) {
              this.typeFilterChart = 1;
              let arrTemp = [];
              let arrDataTemp = [];
              let arrCategoryTemp = [];
              for (let data of responseData.response) {
                let onlyDate = data.day_filter.split(" ")[0];
                arrCategoryTemp.push(onlyDate);
                arrTemp.push(data.count_gestiones);
              }
              arrDataTemp.push({
                data: arrTemp,
              });
              this.seriesBar = arrDataTemp;
              this.totalGen = this.seriesBar.reduce((acc, serie) => {
                return acc + serie.data.reduce((suma, val) => suma + val, 0)
              }, 0);

              this.chartOptionsBar.title.text = "Total: $" + new Intl.NumberFormat('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(this.totalGen);
              this.chartOptionsBar.xaxis.categories = arrCategoryTemp;
              this.panel = [];
            } else if (USUARIOS.length === 1) {
              this.typeFilterChart = 2;
              let arrTemp = [];
              let arrDataTemp = [];
              for (let rangeDates of arrDates) {
                let value = 0;
                for (let data of responseData.response.info) {
                  let arrDatetime = data.day_filter.split(" ");
                  let arrDateInit = arrDatetime[0].split("-");
                  let dateValue = new Date(
                    parseInt(arrDateInit[0]),
                    parseInt(arrDateInit[1]) - 1,
                    arrDateInit[2]
                  );
                  if (this.sonFechasIguales(rangeDates, dateValue)) {
                    value = data.count_gestiones;
                  }
                }
                arrDataTemp.push(value);
              }
              arrTemp.push({
                name: `${responseData.response.name}`,
                data: arrDataTemp,
              });
              this.seriesBar = arrTemp;
              this.totalGen = this.seriesBar.reduce((acc, serie) => {
                return acc + serie.data.reduce((suma, val) => suma + val, 0)
              }, 0);

              this.chartOptionsBar.title.text = "Total: $" + new Intl.NumberFormat('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(this.totalGen);
              this.chartOptionsBar.xaxis.categories = arrStrDate;
              this.panel = [];
            } else if (USUARIOS.length > 1) {
              this.typeFilterChart = 3;
              let arrCategoryTemp = [];
              let arrTemp = [];
              let arrDataTemp = [];
              for (let data of responseData.response) {
                arrCategoryTemp.push(data.name);
                arrTemp.push(data.count_gestiones);
              }
              arrDataTemp.push({
                data: arrTemp,
              });
              this.seriesBar = arrDataTemp;
              this.totalGen = this.seriesBar.reduce((acc, serie) => {
                return acc + serie.data.reduce((suma, val) => suma + val, 0)
              }, 0);

              this.chartOptionsBar.title.text = "Total: $" + new Intl.NumberFormat('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(this.totalGen);
              this.chartOptionsBar.xaxis.categories = arrCategoryTemp;
              this.panel = [];
            }
          } else {
            this.chartOptionsBar.title.text = "Total: $0"
            this.snackbarData.description = `${responseData.msg}`;
            this.snackbarData.openSnackbar = true;
          }
        }
      );

      this.isLoadingFilter = false;
      this.panel = false;
    },
    applyFilterCake: async function () {
      this.chartOptionsPie.labels = [];
      this.seriesPie = [];

      const FECHA_INICIAL = this.formGroup.data.fecha_inicial;
      const FECHA_FINAL = this.formGroup.data.fecha_final;
      const CODIGO_ACCION = this.formGroup.data.codigo_accion;

      let USUARIOS = [];

      if (this.tipoUsuario === "Administrador" || this.tipoUsuario === "Supervisor" || this.tipoUsuario == 'Multiadmin') {
        USUARIOS = this.formGroup.data.usuarios;
        if (USUARIOS === null || USUARIOS === undefined || USUARIOS.length === 0) {
          USUARIOS = [];
        } else {
          let arrTemp = [];
          for (let element of USUARIOS) {
            element = await EncryptService.encrypt(`${element}`);
            arrTemp.push(element);
          }
          USUARIOS = arrTemp;
        }
      } else {
        const ID = localStorage.getItem("ID");
        const ENC_ID = await EncryptService.encrypt(`${ID}`);
        USUARIOS = [ENC_ID];
      }

      let despacho = '';
      if (this.tipoUsuario === "Multiadmin") {
        despacho = this.formGroup.data.despacho;
      } else {
        despacho = localStorage.getItem('DESPACHO');
      }

      const REQUEST_FILTER = {
        fecha_inicial: FECHA_INICIAL,
        fecha_final: FECHA_FINAL,
        codigo_accion: CODIGO_ACCION,
        id_user_list: USUARIOS,
        despacho: despacho
      };

      this.isLoadingFilter = true;
      await EstadisticaService.getDatGrficasByCode(REQUEST_FILTER).then(
        (responseData) => {
          if (
            !responseData.error &&
            responseData.msg !==
            "No hay estadisticas disponibles para este usuario/s"
          ) {
            if (
              USUARIOS === null ||
              USUARIOS === undefined ||
              USUARIOS === "" ||
              USUARIOS.length === 0
            ) {
              this.typeFilterChart = 4;
            } else {
              this.typeFilterChart = 5;
            }
            this.responseFilter = responseData.response;

            let arrLabelsTemp = [];
            let arrDataTemp = [];

            for (let data of responseData.response.gestiones_por_codigo) {
              arrLabelsTemp.push(data.descripcion);
              arrDataTemp.push(data.count_gestiones);
            }

            this.chartOptionsPie.labels = arrLabelsTemp;
            this.chartOptionsPie.plotOptions.pie.donut.labels.total.formatter = () => {
              return responseData.response.total;  // o cualquier valor dinámico que quieras mostrar
            };
            this.seriesPie = arrDataTemp;

            this.panel = [];
          } else {
            this.snackbarData.description = `${responseData.msg}`;
            this.snackbarData.openSnackbar = true;
          }
        }
      );
      this.isLoadingFilter = false;
      this.panel = false;
    },
    getBetweenDates: function (initialDate, finalDate) {
      let arrDatesBetween = [];
      while (initialDate < finalDate) {
        arrDatesBetween.push(new Date(initialDate));
        initialDate.setDate(initialDate.getDate() + 1);
      }
      arrDatesBetween.push(finalDate);
      return arrDatesBetween;
    },
    sonFechasIguales: function (fecha1, fecha2) {
      const year1 = fecha1.getFullYear();
      const month1 = fecha1.getMonth();
      const day1 = fecha1.getDate();

      const year2 = fecha2.getFullYear();
      const month2 = fecha2.getMonth();
      const day2 = fecha2.getDate();

      return year1 === year2 && month1 === month2 && day1 === day2;
    },
    getDespachos: async function () {
      let idUser = await EncryptService.encrypt(localStorage.getItem('ID'));
      await EstadisticaService.getDespachosByUser(idUser).then(async (response) => {
        if (!response.error) {
          let tempArrDespachos = [];
          for (const element of response.response) {
            tempArrDespachos.push({
              id_db: await EncryptService.encrypt(element.nombre_bd),
              id_normal: element.id_despacho,
              nombre: `${element.nombre_bd}`
            })
          }
          this.arrDespachos = tempArrDespachos;
        }
      })
    },
    toggleSelectAll() {
      const usuarios = this.formGroup?.data?.usuarios || [];
      const users = this.arrUsersByGroups || [];
      if (usuarios.length === users.length && users.length > 0) {
        this.formGroup.data.usuarios = [];
      } else {
        this.formGroup.data.usuarios = users.map(user => user.id);
      }
    }
  },
};
</script>

<style scoped>
.text-caption {
  margin-top: -10px;
}
</style>
